import { Button } from "@/components/ui/button";
import { translate as tr } from "../shared/i18n";
import { LockKeyhole, MapPinOff } from "lucide-react";
import { Link } from "react-router-dom";

export function ForbiddenPage() {
  return <div className="system-page"><LockKeyhole size={38}/><span className="eyebrow">{tr("403 · Ограничение доступа")}</span><h1>{tr("Раздел недоступен")}</h1><p>{tr("Ваша роль не содержит разрешение для этой операции. Обратитесь к администратору.")}</p><Button asChild variant="default"><Link className="button primary" to="/dashboard">{tr("Вернуться к обзору")}</Link></Button></div>;
}

export function NotFoundPage() {
  return <div className="system-page"><MapPinOff size={38}/><span className="eyebrow">{tr("404 · Маршрут не найден")}</span><h1>{tr("Такой страницы нет")}</h1><p>{tr("Проверьте адрес или вернитесь в рабочую область.")}</p><Button asChild variant="default"><Link className="button primary" to="/dashboard">{tr("Вернуться к обзору")}</Link></Button></div>;
}
